// ============================================================================
// Section 7 — Final CTA "See it in action" (big green text + gradient fade)
// ============================================================================

import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function FinalCtaSection() {
  return (
    <section
      id="demo"
      className="relative border-t border-border/60 bg-gradient-to-b from-background to-primary/5 py-20 sm:py-28"
    >
      <div className="mx-auto max-w-3xl px-6 text-center">
        <h2 className="text-4xl font-bold leading-tight tracking-tight text-primary sm:text-5xl md:text-6xl">
          See it in action
        </h2>
        <p className="mt-6 text-lg text-muted-foreground sm:text-xl">
          Open the dashboard and run your first turnover workflow in minutes.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Button size="lg" className="rounded-full" asChild>
            <Link to="/login?mode=signup">Start free</Link>
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="rounded-full border-primary text-primary hover:bg-primary/10"
            asChild
          >
            <a href="mailto:welcome@portal.stravo.ai">Get in touch</a>
          </Button>
        </div>
      </div>
    </section>
  );
}
